import request from '@/utils/request'

// 分页查询套餐列表
export function queryListPackage(data) {
  return request({
    url: '/tenant/package/page',
    method: 'post',
    data: data
  })
}

// 变更套餐状态
export function changeStatus(data) {
  return request({
    url: '/tenant/package/changeStatus',
    method: 'post',
    data: data
  })
}

// 套餐详情
export function packageDetail(data) {
  return request({
    url: `/tenant/package/detail/${data.packageId}`,
    method: 'get',
    // data: data
  })
}

// 新增套餐
export function packageSave(data) {
  return request({
    url: '/tenant/package/save',
    method: 'post',
    data: data
  })
}
 // 删除套餐
 export function packageDel(data) {
  return request({
    url: `/tenant/package/delete/${data.packageId}`,
    method: 'delete',
    // data: data
  })
}

// 获取租户列表
export function queryTenant(data) {
  return request({
    url: '/tenant/page',
    method: 'post',
    data: data
  })
}
// 保存租户
export function saveBaseInfo(data) {
  return request({
    url: '/tenant/add',
    method: 'post',
    data: data
  })
}

// 查询所有套餐
export function allSimpleList(data) {
  return request({
    url: '/tenant/package/allSimpleList',
    method: 'get',
    params: data
  })
}
// 查询租户详情 /tenant/baseInfo/{tenantId}
export function queryTenantDetail(data) {
  return request({
    url: `/tenant/baseInfo/${data.tenantId}`,
    method: 'get',
    // params: data
  })
}
// 保存购买套餐
export function saveBuyPackage(data) {
  return request({
    url:  '/tenant/saveBuyPackage',
    method: 'post',
    data: data
  })
}

// 查询租户购买套餐列表
export function buyPackageList(data) {
  return request({
    url:  '/tenant/buyPackageList',
    method: 'post',
    data: data
  })
}

// 套餐添加收费记录
export function addFeeRecord(data) {
  return request({
    url:  '/tenant/addFeeRecord',
    method: 'post',
    data: data
  })
}
//  分页查询收费记录
export function feeRecordList(data) {
  return request({
    url:  '/tenant/feeRecordList',
    method: 'post',
    data: data
  })
}

//  删除收费记录
export function deleteFeeRecord(data) {
  return request({
    url:  `/tenant/deleteFeeRecord/${data.feeRecordId}`,
    method: 'post',
    // data: data
  })
}

// 获取文章列表 /back/article/page
export function queryArticleList(data) {
  return request({
    url: '/back/article/page',
    method: 'post',
    data: data
  })
}

export function changeArticleTenantSortNo(data) {
  return request({
    url: '/back/article/changeTenantSortNo',
    method: 'post',
    data: data
  })
}

// 保存文章
export function saveArticle(data) {
  return request({
    url: '/back/article/save',
    method: 'post',
    data: data
  })
}

// 更改文章状态
export function articleDetail(data) {
  return request({
    url: `/back/article/detail/${data.articleId}`,
    method: 'get',
    params: data
  })
}

// 删除文章
export function articleDelete(data) {
  return request({
    url: `/back/article/delete/${data.articleId}`,
    method: 'delete',
    params: data
  })
}

// 修改文章状态
export function changeStatusArticle(data) {
  return request({
    url: `/back/article/changeStatus`,
    method: 'post',
    data: data
  })
}
// 批量修改文章状态
export function batchChangeStatus(data) {
  return request({
    url: `/back/article/batch/changeStatus`,
    method: 'post',
    data: data
  })
}

// 分页查询文章，产品，案例评论
export function queryComment(data) {
  return request({
    url: '/back/article/comment/page',
    method: 'post',
    data: data
  })
}
// 回复评论
export function replyComment(data) {
  return request({
    url: '/back/article/comment/reply',
    method: 'post',
    data: data
  })
}
// 修改评论状态
export function commentExam(data) {
  return request({
    url: '/back/article/comment/review',
    method: 'post',
    data: data
  })
}

// 官网配置
export function saveWebsite(data) {
  return request({
    url: '/back/officialWebsite/save',
    method: 'post',
    data: data
  })
}
// 获取官网配置
export function getWebsiteDetail(data) {
  return request({
    url: '/back/officialWebsite/detail',
    method: 'get',
    params: data
  })
}

// 名片配置
export function businessCard(data) {
  return request({
    url: '/back/businessCard/save',
    method: 'post',
    data: data
  })
}
// 获取名片类型
export function businessCardDetail(data) {
  return request({
    url: '/back/businessCard/detail',
    method: 'get',
    params: data
  })
}

// 查询企业信息
export function queryCompanyDetail(data) {
  return request({
    url: '/back/company/detail',
    method: 'get',
    params: data
  })
}

// 编辑企业信息
export function companyEdit(data) {
  return request({
    url: '/back/company/edit',
    method: 'post',
    data: data
  })
}

// 查询咨询列表
export function queryInteractList(data) {
  return request({
    url: '/back/interact/page',
    method: 'post',
    data: data
  })
}
// 查询咨询详情列表
export function queryDetailList(data) {
  return request({
    url: '/back/interact/detailList',
    method: 'post',
    data: data
  })
}

// 查询咨询详情列表
export function queryInteractDetail(data) {
  return request({
    url: `/back/interact/detailBaseInfo/${data.interactId}`,
    method: 'get',
  })
}

// 新增文件夹
export function addFolder(data) {
  return request({
    url: '/back/folder/addFolder',
    method: 'post',
    data: data
  })
}
//删除文件夹
export function deleteFolder(data) {
  return request({
    url: `/back/folder/deleteFolder/${data.folderId}`,
    method: 'DELETE'
  })
}
//deleteFolderCheck
//删除文件夹前的校验
export function deleteFolderCheck(data) {
  return request({
    url: `/back/folder/deleteFolderCheck/${data.folderId}`,
    method: 'post'
  })
}
// 查询文件详情
export function folderDetail(data) {
  return request({
    url:`/back/folder/folderDetail/${data.folderId}`,
    method: 'get',
    params: data
  })
}
// 保存文件夹
export function saveFolder(data) {
  return request({
    url:'/back/folder/saveFolder',
    method: 'post',
    data: data
  })
}
// 新增文件
export function saveFile(data) {
  return request({
    url: '/back/folder/saveFile',
    method: 'post',
    data: data
  })
}
// 获取文件列表
export function queryFileList(data) {
  return request({
    url: '/folder/queryFileList',
    method: 'post',
    data: data
  })
}
// 获取文件夹列表
export function queryFolderList(data) {
  return request({
    url: '/folder/queryFolderList',
    method: 'post',
    data: data
  })
}

// 查询公告
export function noticeList(data) {
  return request({
    url: '/system/notice/list',
    method: 'get',
    params: data
  })
}

// 删除公告
export function deleteNotice(data) {
  return request({
    url: `/system/notice/${data.noticeId}`,
    method: 'DELETE',
    // params: data
  })
}

// 修改公告 /system/notice
export function editNotice(data) {
  return request({
    url: '/system/notice',
    method: 'put',
    data: data
  })
}

// 新增公告
export function tenantAddNotice(data) {
  return request({
    url: '/system/notice',
    method: 'post',
    data: data
  })
}
// 公告详情
export function tenantNoticeDetail(data) {
  return request({
    url: `/system/notice/tenantNoticeDetail/${data.noticeId}`,
    method: 'get',
    params: ''
  })
}

// 查询潜在联系人列表
export function queryContactList(data) {
  return request({
    url: '/potential/queryContactList',
    method: 'post',
    data: data
  })
}

// 分配跟进人
export function assign(data) {
  return request({
    url: '/back/potentialContact/assign',
    method: 'post',
    data: data
  })
}
// 查询潜在联系人详情
export function potentialContactDetail(data) {
  return request({
    url: `/back/potentialContact/detail`,
    method: 'post',
    data: data
  })
}

// 查询潜在联系人线索
export function queryClue(data) {
  return request({
    url: '/back/potentialContact/cluePage',
    method: 'post',
    data: data
  })
}

// 查询潜在联系人商机
export function queryBusiness(data) {
  return request({
    url: '/crmBusiness/queryList',
    method: 'post',
    data: data
  })
}
// 查询潜在联系人对应的crm联系人
export function queryCrmContactList (data) {
  return request({
    url: '/crmContact/list',
    method: 'post',
    data: data
  })
}
// 修改水圈文章置顶状态
export function changeTopStatus(data) {
  return request({
    url: '/back/article/changeTopStatus',
    method: 'post',
    data: data
  })
}
// 查询企业文章列表
export function companyArticleListPage(data) {
  return request({
    url: '/back/sqOperate/article/companyArticleListPage',
    method: 'post',
    data: data
  })
}
// 修改首页推荐状态
export function changeHomePageRecommend(data) {
  return request({
    url: '/back/sqOperate/article/changeHomePageRecommend',
    method: 'post',
    data: data
  })
}
// 修改首页置顶状态
export function changeHomePageTop(data) {
  return request({
    url: '/back/sqOperate/article/changeHomePageTop',
    method: 'post',
    data: data
  })
}

// 修改首页推荐状态
export function changeListRecommend(data) {
  return request({
    url: '/back/article/changeListRecommend',
    method: 'post',
    data: data
  })
}

// 查询企业文章列表
export function companyArticleDetail(data) {
  return request({
    url: `/back/sqOperate/article/companyArticleDetail/${data.articleId}`,
    method: 'get',
    params: data
  })
}

// 查询企业列表
export function hallListPage(data) {
  return request({
    url: '/back/sqOperate/company/hallListPage',
    method: 'post',
    data: data
  })
}
// 修改首页推荐状态 企业管理
export function changeRecommend(data) {
  return request({
    url: '/back/sqOperate/company/changeRecommend',
    method: 'post',
    data: data
  })
}
// 修改企业馆展示状态 企业管理
export function changeHallShow(data) {
  return request({
    url: '/back/sqOperate/company/changeHallShow',
    method: 'post',
    data: data
  })
}

// 修改租户排序值
export function changeTenantSortNo(data) {
  return request({
    url: '/back/sqOperate/company/changeSortNo',
    method: 'post',
    data: data
  })
}

// 套餐信息
export function packageInfo(data) {
  return request({
    url: '/back/statistics/packageInfo',
    method: 'get',
    params: data
  })
}

// 系统公告
export function tenantNoticeList(data) {
  return request({
    url: '/system/notice/tenantNoticeList',
    method: 'get',
    params: data
  })
}

// 营销统计
export function marketingStatistics(data) {
  return request({
    url: '/statistics/marketingStatistics',
    method: 'get',
    params: data
  })
}

// // 内容统计
// export function contentStatistics(data) {
//   return request({
//     url: '/statistics/contentStatistics',
//     method: 'get',
//     params: data
//   })
// }
// 营销概况
export function marketingGeneralInfo(data) {
  return request({
    url: '/back/statistics/marketingGeneralInfo',
    method: 'get',
    params: data
  })
}

// 数据概况
export function generalInfo(data) {
  return request({
    url: '/tenant/statistics/generalInfo',
    method: 'get',
    params: data
  })
}
// 销售统计
export function saleTrend(data) {
  return request({
    url: '/tenant/statistics/saleTrend',
    method: 'get',
    params: data
  })
}

// 查询企业名片列表
export function userBusinessCardList(data) {
  return request({
    url: '/back/businessCard/userBusinessCardList',
    method: 'get',
    params: data
  })
}

// 查询文件详情
export function fileDetail(data) {
  return request({
    url:`/back/folder/fileDetail/${data.fileId}`,
    method: 'get',
    params: data
  })
}
// 删除文件
export function deleteFile(data) {
  return request({
    url:`/back/folder/deleteFile/${data.fileId}`,
    method: 'DELETE',
    // params: data
  })
}

// 修改租户套餐状态
export function changePackageStatus(data) {
  return request({
    url:'/tenant/changePackageStatus',
    method: 'post',
    data: data
  })
}

// 查询租户员工列表
export function tenantUserList(data) {
  return request({
    url:'/tenant/tenantUserList',
    method: 'post',
    data: data
  })
}

// 添加超管
export function addAdminUser(data) {
  return request({
    url:'/tenant/addAdminUser',
    method: 'post',
    data: data
  })
}

// 图片上传
export function aliyunUpload(data) {
  return request({
    url:'/upload/',
    method: 'post',
    data: data
  })
}

// 有权限的模块列表
export function queryAuthModuleList(data) {
  return request({
    url:'/system/permission/queryAuthModuleList',
    method: 'post',
    data: data
  })
}

// 平台数据-用户统计
export function userStatistics(data) {
  return request({
    url:'/statistics/user/userStatistics',
    method: 'post',
    data: data
  })
}

// 平台数据-名片统计
export function cardStatistics(data) {
  return request({
    url:'/statistics/card/cardStatistics',
    method: 'post',
    data: data
  })
}

// 平台数据-名片统计-排行
export function cardRankingStatistics(data) {
  return request({
    url:'/statistics/card/cardRankingStatistics/page',
    method: 'post',
    data: data
  })
}

// 平台数据-内容统计
export function contentStatistics(data) {
  return request({
    url:'/statistics/content/contentStatistics',
    method: 'post',
    data: data
  })
}

// 平台数据-内容统计-排行
export function contentRankingStatistics(data) {
  return request({
    url:'/statistics/content/contentRankingStatistics',
    method: 'post',
    data: data
  })
}

// 平台数据-用户统计-趋势图
export function userTrend(data) {
  return request({
    url:'/statistics/user/userTrend',
    method: 'post',
    data: data
  })
}
